import { ReactElement } from 'react'
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

interface Props extends LoadingButtonProps {
  children?: string | ReactElement
}

const AlignmentButton = ({ children, ...props }: Props): ReactElement => (
  <LoadingButton
    variant="contained"
    color="primary"
    startIcon={<VerticalAlignTopIcon />}
    {...props}
  >
    {children ?? 'Ausrichten'}
  </LoadingButton>
)

export default AlignmentButton
